import React, { useState, useEffect } from "react";
import styles from "./PriceCreateComponent.module.css";
import CustomInput from "@components/CustomInput/CustomInput";
import Button from "@components/Button";
import { notify } from "src/utils/notify";
import usePopup from "@hooks/usePopup";
import ConfirmDetailsPopup from "@components/ConfirmDetailsPopup/ConfirmDetailsPopup";
import DetailTableComponent from "@components/DetailTableComponent/DetailTableComponent";
import useWindowSize from "@hooks/useWindowSize";
import { useNavigate } from "react-router";
import { Home } from "@mui/icons-material";
import { createPrice } from "@services/prices/createPrice"; 

const PriceCreateComponent = () => {
  const [creating, setCreating] = useState(true);
  const priceData = {
    doctorId: "",
    OY0240003: 0,
    OY0240006: 0,
    OY0240012: 0,
  };
  const [rows, setRows] = useState([]);
  const [priceDetails, setPriceDetails] = useState(priceData);
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const { handlePopupCenterOpen, handlePopupCenterComponentRender } = usePopup();

  const handleInputChange = ({ target }) => {
    const { name, value } = target;
    setPriceDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    const createdRows = Object.keys(priceDetails).map((key) => {
      if (typeof priceDetails[key] === "object") {
        return Object.keys(priceDetails[key]).map((subKey) => ({
          name: subKey,
          code: (
            <CustomInput
              value={priceDetails[key][subKey] || ""}
              name={subKey}
              onChange={(event) => {
                setPriceDetails((prevState) => ({
                  ...prevState,
                  settledPrice: {
                    ...prevState.settledPrice,
                    [subKey]: event.target.value,
                  },
                }));
              }}
            />
          ),
        }));
      }
      return {
        name: key,
        code: (
          <CustomInput
            value={priceDetails[key] || ""}
            name={key}
            onChange={handleInputChange}
          />
        ),
      };
    });
    setRows(createdRows.flat());
  }, [priceDetails]);

  const columns = [
    { id: "name", label: "Name", minWidth: 170 },
    { id: "code", label: "Value", minWidth: 170 },
  ];

  const handleSave = async () => {
    try {
      const response = await createPrice(priceDetails);
      if (response.status === 200) {
        notify("Price created successfully!", "success");
        navigate("/manageprice");
      }
    } catch (error) {
      notify("Failed to create price. Please try again.", "error");
      console.error("Error creating price:", error);
    }
  };

  const handleCancel = () => {
    setPriceDetails(priceData);
    navigate("/manageprice");
  };

  const handleNavigateDashboard = () => {
    navigate("/");
  };

  return (
    <div className={styles.Wrapper}>
      <div className={styles.BreadCrumb}>
        <div className={styles.NavigationWrapper}>
          <Home className={styles.HomeIcon} onClick={handleNavigateDashboard} />{" "}
          <div>
            <span
              className={styles.DashboardText}
              onClick={handleNavigateDashboard}
            >
              Dashboard
            </span>
            <span
              className={`${styles.RouteText} ${styles.CursorPointer}`}
              onClick={() => navigate("/manageprice")}
            >
              / Price
            </span>
            <span className={styles.RouteText}> / Create New</span>
          </div>
        </div>
        <div className={styles.BtnWrapper}>
          <Button btnType={"primary"} text={"Save"} onClick={handleSave} />
          <Button btnType={"secondary"} text={"Cancel"} onClick={handleCancel} />
        </div>
      </div>
      <DetailTableComponent rows={rows} columns={columns} />
    </div>
  );
};

export default PriceCreateComponent;
